import React, { useEffect } from 'react';
//When finished the development, you must change the name applicationSettings.local.js to applicationSettings.js, in order to Octopus make the changes
//during deployment.
//If you're going to deploy it, wheter on INT(DEV), UAT(QA) or PROD, you must change the line below to import './applicationSettings.js'. 
//Otherwhise, deployment pipeline will break.
import './applicationSettings.js';
import './themes/theme.css';
import { ThemeProvider } from "@woodmac-hycb/theme-provider";
import { getTheme } from "@woodmac-hycb/theme-default";
import './custom.css';
import Home from './components/Home';
import { ToggleRegionProvider } from "./hooks/useToggleRegion";

export default function App() {
    useEffect(() => {
        // If the user has selected a theme, use that
        const selectedTheme = localStorage.getItem("theme");

        if (selectedTheme) {
            document.body.classList.add(selectedTheme);

            // Else if the user's OS preferences prefer dark mode
        } else if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
            document.body.classList.add("dark");

            // Else use light mode
        } else {
            document.body.classList.add("light");
        }
    }, []);

    return (
        <ThemeProvider theme={getTheme()}>
            <ToggleRegionProvider>
                <Home />
            </ToggleRegionProvider>
        </ThemeProvider>
    );
}